import React from 'react';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '&.disabled': {
      '& .MuiSlider-track': {
        backgroundColor: '#9e9e9e !important',
      },
      '& .MuiSlider-rail': {
        backgroundColor: '#9e9e9e !important',
      },
    },
  },
  disabledThumb: {
    backgroundColor: '#9e9e9e !important',
  },
});

interface LevelSliderProps {
  label: string;
  min: number;
  max: number;
  value: number;
  color: string;
  cBack(val: number, l: string): void;
  error: boolean;
}

const LevelSlider = (props: LevelSliderProps) => {
  const { cBack, error, label, min, max, value } = props;
  const [sliderValue, setSliderValue] = React.useState<number>(value);
  const classes = useStyles();

  const handleChange = (event: Event, newValue: number | number[]) => {
    setSliderValue(newValue as number);
    cBack(newValue as number, label);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <h4 style={{ padding: '0 .5em 0 0' }}>{label}</h4>
      <Slider
        valueLabelDisplay="auto"
        color={error ? "secondary" : "primary"}
        step={1}
        min={min}
        max={max}
        value={sliderValue}
        onChange={handleChange}
        aria-labelledby="input-slider"
        className={!sliderValue ? classes.root + ' disabled' : classes.root}
        classes={{
          thumb: !sliderValue ? classes.disabledThumb : '',
        }}
      />
      <p style={{ marginTop: '10px', marginLeft: '10px' }}>
        {sliderValue ? sliderValue + '%' : 'OFF'}
      </p>
    </div>
  );
};

export default LevelSlider;
